
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 19v-5h4v5a1 1 0 001 1h3a1 1 0 001-1v-7h1.7a.5.5 0 00.33-.87L12.67 3.6a1.008 1.008 0 00-1.34 0l-8.36 7.53a.5.5 0 00.33.87H5v7a1 1 0 001 1h3a1 1 0 001-1z"}})])
          )
        }
      }
    